// Elio Ribas \u2014 RFID Reader Adapter Pattern
// Interfaz com\u00fan que cualquier adapter debe implementar.
// El factory `getRFIDReader()` decide cu\u00e1l usar seg\u00fan la plataforma y la configuraci\u00f3n.
// Mantiene una INSTANCIA SINGLETON para que todos los componentes compartan el mismo lector
// y los listeners se mantengan estables.

import { getMeta, setMeta, META } from '@/lib/db';
import { SimulatorAdapter } from '@/lib/rfid/SimulatorAdapter';
import { HIDKeyboardAdapter } from '@/lib/rfid/HIDKeyboardAdapter';

let _instance = null;
let _instanceMode = null;

// Modos retirados (ya no hay adapter): algunos dispositivos pueden tener uno
// de estos guardado de una versión anterior. Se migran en silencio a 'hid'
// la primera vez que se resuelve el modo, sin que el usuario note nada.
const LEGACY_MODES = ['web-bluetooth', 'capacitor'];

async function buildReader(mode) {
  switch (mode) {
    case 'hid':
      return new HIDKeyboardAdapter();
    case 'simulator':
    default:
      return new SimulatorAdapter();
  }
}

/** Lee el modo guardado y migra automáticamente los modos retirados a 'hid'. */
export async function resolveReaderMode() {
  const raw = (await getMeta(META.READER_MODE, 'simulator')) || 'simulator';
  if (LEGACY_MODES.includes(raw)) {
    await setMeta(META.READER_MODE, 'hid');
    return 'hid';
  }
  return raw;
}

/**
 * Singleton-style accessor for the RFID reader.
 * Reads the mode from settings (meta.reader_mode) and reuses the instance until the mode changes.
 */
export async function getRFIDReader() {
  const mode = await resolveReaderMode();
  if (!_instance || _instanceMode !== mode) {
    if (_instance && _instance.disconnect) {
      try { await _instance.disconnect(); } catch (_) {}
    }
    _instance = await buildReader(mode);
    _instanceMode = mode;
  }
  return _instance;
}

/** Resets the singleton (e.g. after Settings change). */
export async function resetReader() {
  if (_instance && _instance.disconnect) {
    try { await _instance.disconnect(); } catch (_) {}
  }
  _instance = null;
  _instanceMode = null;
}
